import { useState, useEffect } from 'react';
import {
    getAccessTokenHyperverge,
    getHypervergeSync,
    getTransactionIdHyperverge,
    getUserKycStatus
} from "../services/waitlist-service";
import { getToken } from '../../core/helpers/tokenHelper';
import { utils } from '../../core/helpers/utils';

const useHypervergeVerification = () => {
    const [accessToken, setAccessToken] = useState();
    const [userToken, setUserToken] = useState();
    const [transactionId, setTransactionId] = useState();
    const [workFlow, setWorkFlow] = useState();
    const [userData, setUserData] = useState();
    const [hypervergeSuccess, setHypervergeSuccess] = useState(false)
    const [hypervergeFailure, setHypervergeFailure] = useState(false)
    const [loaderHyperverge, setLoaderHyperverge] = useState(false)
    const [errorsHyperverge, setErrorsHyperverge] = useState()
    const [uniqueIdHyper, setUniqueIdHyper] = useState()
    const [userCancelled, setUserCancelled] = useState(false)
    const maxAttempts = 3;
    let attempts = 0;
    const pollingInterval = 3000;
    let poll;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const accessTokenResponse = await getAccessTokenHyperverge().then(result => {
                    return utils.parsePayload(result);
                });
                if (!accessTokenResponse || !accessTokenResponse.success) {
                    throw new Error("Not able to fetch accessTokenResponse");
                }
                setAccessToken(accessTokenResponse.data.token);
                let transactionIdResponse = await getTransactionIdHyperverge().then(result =>{
                    return utils.parsePayload(result);
                });
                
                if (!transactionIdResponse || !transactionIdResponse.success) {
                    throw new Error("Not able to fetch transactionIdResponse");
                }
                setTransactionId(transactionIdResponse.data.transactionId);
                setUniqueIdHyper(transactionIdResponse.data.uniqueDeviceId)
                setWorkFlow(transactionIdResponse.data.workflowId);
                setUserData(transactionIdResponse.data)
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();

    }, []);

    const syncResponseHyperverge = async () => {
        try {
            const hypervergeData = await getHypervergeSync(true).then(result => {
                return utils.parsePayload(result);
            });
            if (!hypervergeData || !hypervergeData.success) {
                throw new Error("Not able to fetch hypervergeData");
            } else if (hypervergeData) {
                setErrorsHyperverge(hypervergeData.data.errorMessage)
                attempts = 5
                setLoaderHyperverge(false)
                switch (hypervergeData.data.hypervergeStatus) {
                    case "rejected":
                        setHypervergeSuccess(true)
                        break;
                    case "retry":
                        setUserCancelled(true)
                        break;
                    case "underProcess":
                        // sendDataToTpd()
                        setHypervergeFailure(true)
                        break;
                    case "auto_declined":
                        setHypervergeSuccess(true)
                        break;
                    case "needs_review":
                        // sendDataToTpd()
                        setHypervergeFailure(true)
                        break;
                    default:
                        setHypervergeSuccess(true)
                        break;
                }
            }
        } catch (err) {
            if (attempts > 4) {
                setHypervergeSuccess(true)
            }
        }
    }

    const startPolling = () => {
        setLoaderHyperverge(true)
        poll = setInterval(() => {
            if (attempts < 5) {
                attempts = attempts + 1;
                syncResponseHyperverge();
            } else {
                setLoaderHyperverge(false)
                clearInterval(poll);
            }
        }, pollingInterval);
    };


    const reinitiateHyperverge = () =>{
        setHypervergeSuccess(false)
        setUserCancelled(false)
    }


    useEffect(() => {
        return () => {
            clearInterval(poll);
        };
    }, [attempts]);

    const toggleHypervergeSuccess = () => {
        setHypervergeSuccess(!hypervergeSuccess)
        window.location.reload()
    }

    const toggleUserCancelled = () =>{
        setUserCancelled(!userCancelled)
        window.location.reload()
    }

    const toggleHypervergeFailure = () => {
        setHypervergeFailure(!hypervergeFailure)
        window.location.reload()
    }

    const sendDataToTpd = async () => {
        await getUserKycStatus({ "X-product": 'orobonds:default' })
            .then((response) => {
                if (response && response.success) {
                    // setHypervergeFailure(true)
                } else {
                    console.log("err")
                }
            });
    }

    const hypervergeVerification = () => {
        const token = getToken();
        setUserToken(token);
        const hyperKycConfig = new window.HyperKycConfig(
            accessToken,
            workFlow,
            transactionId,
        );
        if (workFlow === "icm-partial") {
            const customInputs = {
                email : userData?.initialData?.email ? userData?.initialData?.email : "NA",
                phoneNumber : userData?.initialData?.phoneNumber ? userData?.initialData?.phoneNumber : "NA",
                date: userData?.initialData?.date ? userData?.initialData?.date : "NA",
                // stringphoneNumber : userData?.initialData?.stringphoneNumber ? userData?.initialData?.stringphoneNumber : "NA",
                branchCode : userData?.initialData?.branchCode ? userData?.initialData?.branchCode : "NA",
                fullName: userData?.initialData?.fullName ? userData?.initialData?.fullName : "NA",
                aadhaarNumber: userData?.initialData?.aadhaarNumber ? userData?.initialData?.aadhaarNumber : "NA",
                panNumber: userData?.initialData?.panNumber ? userData?.initialData?.panNumber : "NA",
                empName : userData?.initialData?.empName ? userData?.initialData?.empName : "NA",
                empDesignation : userData?.initialData?.empDesignation ? userData?.initialData?.empDesignation : "NA",
                branch : userData?.initialData?.branch ? userData?.initialData?.branch : "NA",
                dpId: userData?.initialData?.dpId ? userData?.initialData?.dpId : "NA",
                // icm_token: token ? token : "NA",
                empCode: userData?.initialData?.empCode ? userData?.initialData?.empCode : "NA",
                panCollected: userData?.initialData?.panCollected ? userData?.initialData?.panCollected : "NA",
                poiCollected: userData?.initialData?.poiCollected ? userData?.initialData?.poiCollected : "NA",
                permanentAddressCheck: userData?.initialData?.permanentAddressCheck ? userData?.initialData?.permanentAddressCheck : "NA",
                aadhaarFile: userData?.initialData?.aadhaarFile ? userData?.initialData?.aadhaarFile : "NA",
                selfie: userData?.initialData?.selfie ? userData?.initialData?.selfie : "NA",
                panFile: userData?.initialData?.panFile ? userData?.initialData?.panFile : "NA",
                address: userData?.initialData?.address ? userData?.initialData?.address : "NA",
                city: userData?.initialData?.city ? userData?.initialData?.city : "NA",
                district: userData?.initialData?.district ? userData?.initialData?.district : "NA",
                state: userData?.initialData?.state ? userData?.initialData?.state : "NA",
                pincode: userData?.initialData?.pincode ? userData?.initialData?.pincode : "NA",
                country: "India",
                countryCode: "+91",
                gender: userData?.initialData?.gender ? userData?.initialData?.gender : "NA",
                dob: userData?.initialData?.dob ? userData?.initialData?.dob : "NA",
                accountNumber : userData?.initialData?.accountNumber ? userData?.initialData?.accountNumber : "NA",
                ifsc : userData?.initialData?.ifsc ? userData?.initialData?.ifsc : "NA",
                clientId: userData?.initialData?.clientId ? userData?.initialData?.clientId : "NA",
                depositoryName: userData?.initialData?.depositoryName ? userData?.initialData?.depositoryName : "NA",
                depositoryParticipantName : userData?.initialData?.depositoryParticipantName ? userData?.initialData?.depositoryParticipantName : "NA",
                income: userData?.initialData?.income ? userData?.initialData?.income : "NA",
                cheque: userData?.initialData?.cheque ? userData?.initialData?.cheque : "NA",
        }
            hyperKycConfig.setInputs(customInputs)
        }
        else if (workFlow === "icm-flow") {
            const customInputs = {
                email: userData?.initialData?.email ? userData?.initialData?.email : "NA",
                phoneNumber: userData?.initialData?.phoneNumber ? userData?.initialData?.phoneNumber : "NA",
                date: userData?.initialData?.date ? userData?.initialData?.date : "NA",
                icm_token: userData?.initialData?.token ? userData?.initialData?.token : "NA",
                // stringphoneNumber : userData?.initialData?.stringphoneNumber ? userData?.initialData?.stringphoneNumber : "NA",
                branchCode : userData?.initialData?.branchCode ? userData?.initialData?.branchCode : "NA",
                empName : userData?.initialData?.empName ? userData?.initialData?.empName : "NA",
                empDesignation : userData?.initialData?.empDesignation ? userData?.initialData?.empDesignation : "NA",
                branch : userData?.initialData?.branch ? userData?.initialData?.branch : "NA",
                empCode: userData?.initialData?.empCode ? userData?.initialData?.empCode : "NA",
            }
            hyperKycConfig.setInputs(customInputs)
        }
        hyperKycConfig.setUniqueId(uniqueIdHyper)

        const handler = (HyperKycResult) => {
            startPolling();
            // switch (HyperKycResult.status) {
            //     case "user_cancelled":
            //         // setHypervergeSuccess(true)
            //         break;
            //     case "error":
            //         setHypervergeSuccess(true)
            //         break;
            //     case "auto_approved":
            //         // sendDataToTpd()
            //         setHypervergeFailure(true)
            //         break;
            //     case "auto_declined":
            //         setHypervergeSuccess(true)
            //         break;
            //     case "needs_review":
            //         // sendDataToTpd()
            //         setHypervergeFailure(true)
            //         break;
            //     default:
            //         sendDataToTpd()
            //         break;
            // }
        }
        window.HyperKYCModule.launch(hyperKycConfig, handler);
    };

    return { toggleHypervergeSuccess, hypervergeSuccess, toggleHypervergeFailure, hypervergeFailure, hypervergeVerification, loaderHyperverge, errorsHyperverge, userCancelled, toggleUserCancelled, reinitiateHyperverge };
};

export default useHypervergeVerification;